import m, { parseQueryString } from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { mounter } from "oj-dom-utils";
import { getTranslation } from "../../translation";
import { Form } from "oj-form-utils";
import { InputField } from "../forms/inputField";
import { cleanString } from "oj-utils";
import { getBaseUrl } from "../../utils";

interface INewsletterForm {
    btnText?: string
    group?: boolean
}

export class NewsletterForm extends MithrilTsxComponent<INewsletterForm> {
    form = new Form({
        subscribeEmailAddress: Form.field<any>("", null, {
            required: getTranslation('fieldEmailMessage'),
            patterns: [{ pattern: Form.patterns.email, message: getTranslation('invalidEmail') }],
        }, "text", { placeholder: getTranslation('fieldEmailAddressLabel') }),
    })
    isLoading = false;
    isSuccess = false;

    view(v: m.Vnode<INewsletterForm>) {
        const errorMessage = this.form.getErr("subscribeEmailAddress");
        const field = this.form.getFields().subscribeEmailAddress;
        const id = field.key;
        delete field.key;

        return <div className="newsletter-form">
            {this.isSuccess
                ? <div className="success-message">
                    <header>
                        <span className="title h5">{getTranslation('newsletterSuccess')}</span>
                    </header>
                </div>
                : <div className="form">
                    <div className="form-group">
                        <div className={cleanString("form-input", v.attrs.group && "group")}>
                                {["subscribeEmailAddress"].map(Form.fieldHelper<any>(this.form, field => <InputField id={id} {...field} type="text" />))}
                                <button className="btn-secondary" type="submit" onclick={async () => await this.onSubmit(v)} disabled={this.isLoading}>
                                    {v.attrs.btnText ?? getTranslation('newsletterSubscribe')}
                                </button>
                          
                        </div>
                        {errorMessage && <div className="error">{errorMessage[0]}</div>}
                    </div>
                </div>}
        </div>
    }

    async onSubmit(v: m.Vnode<INewsletterForm>) {
        if (!this.form.validate()) {
            m.redraw()
            return;
        }

        this.isLoading = true

        try {
            await fetch(`${getBaseUrl()}/Popup/NewsletterPopupSubscribeForm`, {
                method: "POST",
                headers: { "Content-Type": "application/json", "Accept-Language": window["culture"] },
                body: JSON.stringify(this.form.toJSON())
            }).then(res => res.json()).then(res => {
                if (res.email) {
                    this.isSuccess = true
                    window.ojtag("newsletter_subscribe", {
                        form_type: "newsletter",
                        ...window.GTM_CUSTOMER
                    })
                }
                else
                    this.form.fields.subscribeEmailAddress.errors = [res.error]
            })
        } catch (error) {
            console.error(error)
        } finally {
            this.isLoading = false
            m.redraw()
        }
    }
}

mounter<INewsletterForm>(`[data-m-newsletter-form]`, async (r, d) => {

    const data = {
        group: true
    }

    m.mount(r, {
        oncreate: dom => r.replaceWith(dom.dom),
        view: v => <NewsletterForm {...data} />
    })
})